(function() { window.GUID_84b8e647_d2fe_4fd0_8274_4c29a3b7ac23 = { getGuid: function() { return "84b8e647-d2fe-4fd0-8274-4c29a3b7ac23"; } }; })();
var GoogleLocation;
(function (GoogleLocation) {
    class GoogleLocationAutoComplete {
        BindToInput(autocompleteInputId, hiddenId, hiddenValue, resultId) {
            var me = this;
            if (resultId != null) {
                me.ResultContainer = $('#' + resultId);
            }
            me.$AutoCompleteInput = $('#' + autocompleteInputId);
            me.$HiddenIdInput = $('#' + hiddenId);
            me.$HiddenValueInput = $('#' + hiddenValue);
            var url = me.$AutoCompleteInput.data('apiurl');
            if (url) {
                this.loadScript(url, function () {
                    if (me.$AutoCompleteInput.length > 0) {
                        me.$AutoCompleteInput = me.$AutoCompleteInput;
                        var options = {
                        //types: ['address'] /*ne pas mettre, sinon, la recherche est trop limité*/ 
                        };
                        var autocomplete = new google.maps.places.Autocomplete(me.$AutoCompleteInput[0], options);
                        var inputName = me.$AutoCompleteInput[0].name;
                        if (inputName != "") {
                            var geoLoc = me.$AutoCompleteInput.data('value');
                            if (geoLoc != "" && geoLoc != null) {
                                geoLoc.HtmlFormattedAddress = ""; /*Evite le japage sur un post parce que aime pas html injection*/
                            }
                            me.$HiddenIdInput.val(JSON.stringify(geoLoc));
                            me.$AutoCompleteInput.attr("name", inputName + "InputText");
                        }
                        google.maps.event.addListener(autocomplete, 'place_changed', function () {
                            me.PlaceSelected(autocomplete.getPlace());
                        });
                        if (me.ResultContainer.length > 0) {
                            if (me.ResultContainer.html() != "") {
                                if (me.OnResultContainerLoaded != null) {
                                    me.OnResultContainerLoaded();
                                }
                            }
                            const emptyResultContainer = () => {
                                me.ResultContainer.empty();
                                me.$HiddenIdInput.val(null);
                                me.$HiddenValueInput.val(null);
                                if (me.OnResultContainerCleared != null) {
                                    me.OnResultContainerCleared();
                                }
                            };
                            me.ResultContainer.on('click', '.ClearButton', function () {
                                const $googleLocationContainer = me.ResultContainer.find(".GoogleLocation");
                                if ($googleLocationContainer.length && $googleLocationContainer.hasClass("xyz-in")) {
                                    $googleLocationContainer.removeClass("xyz-in");
                                    $googleLocationContainer.addClass("xyz-out");
                                    CS.Lag("google-location-dispose-container", 300, () => {
                                        $googleLocationContainer.slideUp(null, () => {
                                            emptyResultContainer();
                                        });
                                    });
                                }
                                else {
                                    emptyResultContainer();
                                }
                            });
                        }
                        /*Patch, sinon, lorsque l'on click enter en choisissant un element de l'autocomplete google, on triggait le prochain bouton*/
                        $('<button style="width:0;height:0;opacity:0;border:none;padding:0;" id="FakeLinkToAvoidBug" onclick="return false;"></button>').insertAfter(me.$AutoCompleteInput);
                    }
                });
            }
        }
        loadScript(url, callback) {
            if (window["google"])
                if (google.maps)
                    if (google.maps.places)
                        if (google.maps.places.Autocomplete) {
                            callback();
                            return;
                        }
            $.getScript(url, callback);
        }
        PlaceSelected(place) {
            var me = this;
            me.$AutoCompleteInput.val("");
            if (typeof (place.geometry) == "undefined") {
                return;
            }
            var googleLocation = {
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
                name: place.name,
                street_number: '',
                postal_code: '',
                postal_code_prefix: '',
                route: '',
                locality: '',
                stateShort: '',
                stateLong: '',
                countryShort: '',
                countryLong: '',
                place_id: place.place_id,
                url: place.url,
                formatted_address: place.formatted_address
            };
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (addressType == "administrative_area_level_1") {
                    googleLocation['stateShort'] = place.address_components[i]['short_name'];
                    googleLocation['stateLong'] = place.address_components[i]['long_name'];
                }
                else if (addressType == "country") {
                    googleLocation['countryShort'] = place.address_components[i]['short_name'];
                    googleLocation['countryLong'] = place.address_components[i]['long_name'];
                }
                else if (typeof (googleLocation[addressType]) != undefined) {
                    googleLocation[addressType] = place.address_components[i]['long_name'];
                }
            }
            var data = { googleLocation: JSON.stringify(googleLocation) };
            const url = CS.Url.CSUrl('GetGoogleLocationFormattedWithTimeZone');
            if (url == null) {
                console.error("Url for GetGoogleLocationFormattedWithTimeZone is null");
            }
            CS.Ajax.Post(url, data, function (response) {
                if (me.ResultContainer.length > 0) {
                    me.ResultContainer.empty().append(response.HtmlFormattedAddress);
                    response.HtmlFormattedAddress = ""; /*Je vais ca, sinon, le post va japper avec le contenu HTML*/
                    me.$HiddenValueInput.val(JSON.stringify(response));
                    me.$HiddenIdInput.val(response.place_id);
                    if (me.OnPlaceSelected != null) {
                        me.OnPlaceSelected(place);
                    }
                }
            });
        }
    }
    GoogleLocation.GoogleLocationAutoComplete = GoogleLocationAutoComplete;
    function GetLocation(callback) {
        if (navigator.geolocation) {
            navigator.geolocation.watchPosition(callback);
        }
        else {
            callback(null);
        }
    }
    GoogleLocation.GetLocation = GetLocation;
})(GoogleLocation || (GoogleLocation = {}));

//# sourceMappingURL=google-location.js.map
